import React from 'react'
import { array } from 'prop-types'
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import DateTime from '../../../components/library/common/DateTime'
import EmdashText from '../../../components/library/common/EmdashText'
import HrbTranslate from '../../../components/language/HrbTranslate'
import CollapsibleCardContent from '../../../components/library/stacking-collapsible-cards/CollapsibleCardContent'
import CollapsibleCardHeader from '../../../components/library/stacking-collapsible-cards/CollapsibleCardHeader'
import StackableCardWrapper from '../../../components/library/stacking-collapsible-cards/StackableCardWrapper'

const AuditProtectionCard = ({ paymentInfo, returnInfo }) => {

    const expiryIntervalYears = 7

    var expiryDateString = ''
    for (var j = 0; j < paymentInfo.length; j++) {
        if ((paymentInfo[j].productSkuName.indexOf('Protection') !== -1 || (paymentInfo[j].hasAuditProtection))) {
            expiryDateString = new Date(paymentInfo[j].purchaseDate)
            expiryDateString.setFullYear(expiryDateString.getFullYear() + expiryIntervalYears)
            expiryDateString = expiryDateString.toString()
            break;
        }
    }

    var isSelected = returnInfo?.upgrades?.includes('Audit Protection');

    return (
        <StackableCardWrapper className='card-audit-protection'>
            <CollapsibleCardHeader>
                <div className='column is-9'>
                    <h4><HrbTranslate text='ReturnInfo.Headers.AuditProtection' /></h4>
                </div>
            </CollapsibleCardHeader>
            <CollapsibleCardContent className='light-grey py-3'>
                <div className='column is-4'>
                    <VerticalNameChildren textKey='ReturnInfo.Labels.Status'>
                        {expiryDateString ?
                            <p className='p1 bold-weight'><HrbTranslate text='ReturnInfo.Labels.Purchased' /></p> :
                            isSelected ? <p className='p1 bold-weight'><HrbTranslate text='ReturnInfo.Labels.Selected' /></p> :
                                <p className='p1 bold-weight'><HrbTranslate text='ReturnInfo.Labels.NotPurchased' /></p>}
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren textKey='ReturnInfo.Labels.ExpiryDate'>
                        {expiryDateString ?
                            <p className='p1 bold-weight'><DateTime value={expiryDateString} /></p> :
                            <p className='p1 bold-weight'><EmdashText /></p>}
                    </VerticalNameChildren>
                </div>
            </CollapsibleCardContent>
        </StackableCardWrapper>
    );
}

AuditProtectionCard.propTypes = {
    paymentInfo: array,
}

export default AuditProtectionCard
